import { Box, styled, Typography } from '@mui/material';
import { CandidateMatchArchiveCardInterface } from 'features/Connect/features/ConnectCandidatePortalDashboards/CandidateMatchDashboard/utils/types';
import { SchoolInfoHighlightRow } from '../HighlightRows';
import { PreferenceMatchesSection } from '../PreferenceMatches/PreferenceMatchesSection';
import { ConnectCandidateMatchArchiveCardDataTestIds } from 'data-testids/CandidatePortalDataTestIds';

interface CandidateMatchArchiveCardHeaderProps {
  archivedMatch: CandidateMatchArchiveCardInterface['archivedMatch'];
}

export const CandidateMatchArchiveCardHeader: React.FC<CandidateMatchArchiveCardHeaderProps> = ({
  archivedMatch,
}) => {
  const school = archivedMatch?.school;

  return (
    <CardHeader data-testid={ConnectCandidateMatchArchiveCardDataTestIds.HEADER_CONTAINER}>
      <ArchivedMatchCardSchoolSection>
        <SchoolNameAndDistrictContainer
          data-testid={ConnectCandidateMatchArchiveCardDataTestIds.SCHOOL_NAME_TEXT}
        >
          <SchoolNameText>{school?.name}</SchoolNameText>
          <DistrictNameText> at {school?.district?.name}</DistrictNameText>
        </SchoolNameAndDistrictContainer>
        <SchoolInfoHighlightRow school={school} />
        {archivedMatch?.preference_matches && (
          <PreferenceMatchesSection currentMatch={archivedMatch} />
        )}
      </ArchivedMatchCardSchoolSection>
    </CardHeader>
  );
};

const CardHeader = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  position: 'relative',
}));

const ArchivedMatchCardSchoolSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  gap: theme.spacing(2),
}));

const SchoolNameAndDistrictContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.5),
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
    gap: theme.spacing(0.5),
  },
}));

const SchoolNameText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: theme.typography.h3.fontSize,
  fontWeight: theme.typography.fontWeightMedium,
  lineHeight: '119.4%',
}));

const DistrictNameText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: theme.typography.body1.fontSize,
  fontWeight: theme.typography.fontWeightRegular,
  lineHeight: '119.4%',
  [theme.breakpoints.up('md')]: {
    fontSize: theme.typography.h3.fontSize,
    fontWeight: theme.typography.fontWeightMedium,
  },
}));
